import { createActions } from 'reduxsauce'

const { Types, Creators } = createActions({
  /**
   * Store
   */
  reduce_outcome_quotedoc: ['quotedoc'],
  reduce_outcome_support_agency: ['support_agency'],

  /**
   * Sagas
   */
  saga_send_quotedoc: ['args'],
  saga_send_support_agency: ['args'],
})

export const outcomes_types = Types
export const outcomes_creators = Creators
